import getMessage from 'src/background/utils/i18n.utils';
import React, { Fragment, useEffect, useState } from 'react';
export const SlidingBarComponent = (props) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    useEffect(() => {
        const index = props.values.findIndex((item) => item.value === props.selectedValue);
        setSelectedItemIndex(index);
    }, [props.selectedValue]);
    return (React.createElement("div", { className: "sliding-bar-container" },
        React.createElement("div", { className: "tabs" },
            props.values.map((v, index) => (React.createElement(Fragment, { key: `input-${index}` },
                React.createElement("input", { style: {}, type: "radio", id: `${props.id}-radio-${index}`, name: "tabs", checked: v.value === props.selectedValue, onChange: () => {
                        props.onChange(v.value);
                    } }),
                React.createElement("label", { className: `tab ${v.value === props.selectedValue ? 'selected' : ''}`, htmlFor: `${props.id}-radio-${index}` }, v.skipLabelTranslation
                    ? v.label
                    : getMessage(v.label))))),
            React.createElement("span", { className: "glider", style: {
                    transform: `translateX(calc(${selectedItemIndex * 100}%))`,
                } }))));
};
